export const getLocation = state => state.location;
